import React from 'react'
import {
  CFImage,
  CFLink,
  CFView,
  DefaultScreen,
  MobileScreen,
} from 'components'
import { appStore, googlePlay } from 'images'

export default () => {
  return (
    <CFView>
      <MobileScreen>
        <CFView mv="25px" column center>
          <CFView h2 futura bold color="#E02020" mb="20px">
            DOWNLOAD APP
          </CFView>
          <CFView column center white bold>
            <CFView h4 mb="15px" textCenter maxWidth="75vw">
              Burnaby Palace is now taking online orders. Order through our
              website or download our app in your app store! Collect points and
              redeem fantastic rewards!
            </CFView>
            <CFView row center>
              <CFView mr="10px">
                <CFLink href="https://apps.apple.com/us/app/id1522432189">
                  <CFImage
                    h="40px"
                    src={appStore}
                    alt="Burnaby Palace App Store"
                  />
                </CFLink>
              </CFView>
              <CFLink href="https://play.google.com/store/apps/details?id=tech.codefusion.burnabypalace">
                <CFImage
                  h="40px"
                  src={googlePlay}
                  alt="Burnaby Palace Google Play"
                />
              </CFLink>
            </CFView>
          </CFView>
        </CFView>
      </MobileScreen>
      <DefaultScreen>
        <CFView mb="13px" mr="25px" column justifyStart>
          <CFView h2 futura bold color="#E02020" mb="20px" minWidth="250px">
            DOWNLOAD APP
          </CFView>
          <CFView column justifyStart white bold>
            <CFView maxWidth="260px" fontSize="16px" mb="15px">
              Burnaby Palace is now taking online orders. Order through our
              website or download our app in your app store! Collect points and
              redeem fantastic rewards!
            </CFView>
            <CFLink href="https://apps.apple.com/us/app/id1522432189">
              <CFImage
                h="37px"
                mt="5px"
                src={appStore}
                alt="Burnaby Palace App Store"
                hover
              />
            </CFLink>
            <CFLink href="https://play.google.com/store/apps/details?id=tech.codefusion.burnabypalace">
              <CFImage
                h="37px"
                mt="5px"
                src={googlePlay}
                alt="Burnaby Palace Google Play"
                hover
              />
            </CFLink>
          </CFView>
        </CFView>
      </DefaultScreen>
    </CFView>
  )
}
